import { connect } from 'react-redux';

import actions from '../../duck/actions';
import ProjectHub from './ProjectHub';

const mapStateToProps = state => ({
  project: state.projects.project,
  isLoading: state.shared.isLoading,
});

const mapDispatchToProps = dispatch => ({
  getProject: projectId => dispatch(actions.getProject(projectId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectHub);
